import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex, Text, useMultiStyleConfig } from "@chakra-ui/react";
import { SvgSpriteConsumer } from "../../atoms";
import { ProductIconSizes, ProductIconVariant, } from "./ProductIcon.types";
const ProductIcon = ({ iconId, label, variant = ProductIconVariant.GREEN, size = ProductIconSizes.MD, }) => {
    const styles = useMultiStyleConfig("ProductIcon", {
        size,
        variant,
    });
    return (_jsxs(Flex, Object.assign({ alignItems: "center", gap: "2" }, { children: [_jsx(Flex, Object.assign({ sx: styles.container }, { children: _jsx(SvgSpriteConsumer, { svgId: iconId, size: 24 }) })), label && _jsx(Text, Object.assign({ variant: "body.mediumBold" }, { children: label }))] })));
};
ProductIcon.displayName = "ProductIcon";
export default ProductIcon;
//# sourceMappingURL=ProductIcon.js.map